import styled from 'styled-components'

import Icon from '../Icon'

import { DotSize } from './DotNavigation.type'

export const Container = styled.div<{
  disabled?: boolean
}>`
  display: flex;

  gap: ${({ theme }) => theme.dotNavigation.mobile.spaceBetween}px;

  ${({ disabled }) => disabled && 'cursor: not-allowed;'}

  @media (min-width: 768px) {
    gap: ${({ theme }) => theme.dotNavigation.desktop.spaceBetween}px;
  }
`

export const InnerContainer = styled.div`
  max-width: 130px;
  overflow-x: hidden;
  display: flex;

  gap: ${({ theme }) => theme.dotNavigation.mobile.spaceBetween}px;

  scroll-behavior: smooth;

  @media (min-width: 768px) {
    max-width: 312px;

    gap: ${({ theme }) => theme.dotNavigation.desktop.spaceBetween}px;
  }
`

export const ArrowIcon = styled(Icon)<{
  disabled?: boolean
  nonFocusable?: boolean
}>`
  align-self: center;

  ${({ disabled }) =>
    disabled &&
    `
      outline: dashed 1px #45586B;
      border-radius: 1px;
      pointer-events: none;
  `}

  ${({ nonFocusable }) => nonFocusable && 'outline: solid 1px #45586B;'}
`

export const DotContainer = styled.div<{
  nonFocusable?: boolean
  isSelected: boolean
  color?: string
}>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ nonFocusable, isSelected, color = '#0B89E3' }) =>
    nonFocusable &&
    `
      border-width: 1px;
      border-style: solid;
      border-color ${isSelected ? color : '#DDE5ED'};
  `}

  ${({ theme }) => `
    min-width: ${theme.dotNavigation.mobile.containerSize}px;
    height: ${theme.dotNavigation.mobile.containerSize}px;

    @media (min-width: 768px) {
      min-width: ${theme.dotNavigation.desktop.containerSize}px;
      height: ${theme.dotNavigation.desktop.containerSize}px;
    }
  `}
`

export const Dot = styled.div<{
  isSelected: boolean
  size: DotSize
  disabled?: boolean
}>`
  aspect-ratio: 1;
  border-radius: 50%;
  cursor: pointer;

  background-color: ${({ isSelected, color = '#0B89E3' }) =>
    isSelected ? color : '#DDE5ED'};

  transition:
    background-color 0.2s linear,
    width 0.2s ease,
    height 0.2s ease;

  :focus,
  :hover {
    outline: 1px solid #abbed1;

    @media (min-width: 768px) {
      outline: 2px solid #abbed1;
    }
  }

  ${({ disabled }) =>
    disabled &&
    `
      outline: dotted 2px #DDE5ED;
      pointer-events: none;
      background-color: #DDE5ED;
  `}

  ${({ theme, size }) => `
    width: ${theme.dotNavigation.mobile.dotSize[size]}px;
    height: ${theme.dotNavigation.mobile.dotSize[size]}px;

    @media (min-width: 768px) {
      width: ${theme.dotNavigation.desktop.dotSize[size]}px;
      height: ${theme.dotNavigation.desktop.dotSize[size]}px;
    }
  `}
`
